export class GlobalConstants {
    public static readonly COUNTRY_METADATA = {
        USA: {
            countryId: 1,
            countryISO3: 'USA',
            stateCaption: 'State',
            postalCodeCaption: 'ZIP code',
        },
        CAN: {
            countryId: 2,
            countryISO3: 'CAN',
            stateCaption: 'Province',
            postalCodeCaption: 'Postal code',
        },
    };

    public static readonly CLAIM_STATUS = {
        PENDING_PARENT: { id: 4, description: 'Pending Parent' },
        PARENT_SUBMISSION_COMPLETE: { id: 5, description: 'Parent Submission Complete' },
        PARENT_COMPLETE_SCHOOL_UPLOAD: { id: 6, description: 'Parent Submission Complete' },
        PENDING_PHYSICIAN: { id: 18, description: 'Pending Physician' },
        PENDING_EMPLOYER: { id: 24, description: 'Pending Employer' },
    };

    public static readonly CLAIM_TYPE = {
        WITHDRAWAL: 'TRPWithdrawal',
        DISMISSAL: 'TRPDismissal',
        MEDICAL_WITHDRAWAL: 'TRPMedicalWithdrawal',
        MEDICAL_ABSENCE: 'TRPMedicalAbsence',
        JOB_RELOCATION: 'TRPJobRelocation',
        INVOLUNTARY_UNEMPLOYMENT: 'TRPInvoluntaryUnemployment',
    };

    public static readonly FORM_TEXT = {
        SETTLEMENT_AUTHORIZATION: `I hereby authorize A.W.G. Dewar, Inc. to make settlement payable to the above School/College, such settlement to be credited to my account, with any excess to be remitted to me through the School/College.`,
        AUTHORIZATION: `I hereby authorize A. W. G. Dewar, Inc. to make settlement payable to the above School/College, such settlement to be credited to my account, with any excess to be remitted to me through the School/College.`,
        SIGNATURE_AKNOWLEDGEMENT: `By signing and selecting the 'Accept Signature' button, I acknowledge that I am electronically signing this form and that my electronic signature is the same as a handwritten signature for the purpose of validity, enforceability, and admissibility.`,
        INSTRUCTION: `Note: This form should be submitted to Dewar as soon as possible; in any event, not later than 30 days after separation. The information in this form may be shared with your child's school.`,
        MEDICAL_AUTHORIZATION: `I hereby authorize the physician to complete the Attending Physician's Statement and to release this and other information to A.W.G. Dewar, Inc. for their use in documentation of claim for recovery from the insurance contract currently in effect. I also authorize A.W.G. Dewar, Inc. to make refund settlement payable to the school for credit to the student's account.`,
        PHYSICIAN_INSTRUCTION: `Note: This form should be submitted to Dewar as soon as possible; in any event, not later than 30 days after separation.`,
        EMPLOYER_INSTRUCTION: `Note: This form should be submitted to Dewar as soon as possible; in any event, not later than 30 days after separation.`,
        EMPLOYER_JOB_RELOCATION_CERTIFICATION: `We hereby certify that the above information is true and correct.`,
        EMPLOYER_UNEMPLOYMENT_CERTIFICATION: `We hereby certify that the above information is true and correct and that the employee has completely separated from his/her position and employer.`,
        PARENT_JOB_RELOCATION_CERTIFICATION:
            'I certify that I have accepted employment which has resulted in a relocation of our primary and permanent residence of greater than RELOCMILES from the school.',
        PARENT_JOB_RELOCATION_AUTHORIZATION:
            'I HEREBY AUTHORIZE the employer noted above to release the requested information which is required to verify my claim with A.W.G. Dewar, Inc. I further authorize A.W.G. Dewar, Inc. to make settlement payable to the above School, such settlement to be credited to my account, with any excess to be remitted to me through the School.',
        PARENT_UNEMPLOYMENT_CERTIFICATION:
            'I HEREBY CERTIFY that I have become involuntarily unemployed and have completely separated from my position/employer. I understand the benefit period for this coverage ends immediately upon becoming reemployed and I will notify A.W.G. Dewar, Inc. of such employment',
        PARENT_UNEMPLOYMENT_AUTHORIZATION:
            'I HEREBY AUTHORIZE the employer noted above to release the requested information which is necessary to verify my claim with A.W.G. Dewar, Inc. I further authorize A.W.G. Dewar, Inc. to make settlement payable to the above School, such settlement to be credited to my account, with any excess to be remitted to me through the School.',
    };

    public static readonly VALIDATION_REGEX = {
        emailPattern: /^[a-zA-Z0-9._%+-]{1,64}@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$/,
        phonePattern: /^\(?(\d{3})\)?[-. ]?(\d{3})[-. ]?(\d{4})$/,
        zipCode: /^\d{5}(?:-\d{4})?$/,
        canadianPostalCode: /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/,
    };

    public static readonly ERROR_MESSAGES = {
        PROGRESS_ERROR: `We are currently unable to obtain your claim information.`,
        SERVER_ERROR: `We are currently unable to display your claim.`,
        ESC_MESSAGE: `Please try again shortly. If this problem persists, contact our Enterprise Support Center at <a href='tel:8772489500'>877-248-9500</a>.`,
    };

    public static readonly SEPARATION_DATE_DEFINITIONS = {
        WITHDRAWAL: `The date should be the later of the last day attended or the date the family notified the school of the withdrawal.`,
        DISMISSAL: `The date should be the later of the last day attended or the date the student was dismissed by the school.`,
    };

    public static readonly ALLOWED_FILE_TYPES = ['application/pdf', 'image/jpeg', 'image/png', 'image/bmp', 'image/gif', 'image/tiff', 'image/heic'];

    public static readonly SUBMIT_TEXT = {
        DISCLAIMER: `A school official filled out this form and I acknowledge that an email will be sent notifying another school official.`,
        INSTRUCTION: `This claim should be submitted to Dewar together with the parent's claim form as soon as possible; in any event, not later than 30 days after separation.`,
        PARENT_INSTRUCTION: `The parent or guardian's claim form must be submitted not later than 30 days after separation.`,
        PHYSICIAN_INSTRUCTION: `The physician's claim form must be submitted not later than 30 days after separation.`,
        EMPLOYER_INSTRUCTION: `The employer's claim form must be submitted not later than 30 days after separation.`,
    };

    public static readonly ADDRESS_TYPES = {
        BILLING_ADDRESS: 1,
        MAILING_ADDRESS: 2,
        ORIGINAL_EMPLOYER_ADDRESS: 3,
        NEW_EMPLOYER_ADDRESS: 4,
        ORIGINAL_PERSON_ADDRESS: 5,
        NEW_PERSON_ADDRESS: 6,
    };
}
